import { c as _c } from "react/compiler-runtime";
/* istanbul ignore file */
import qs from 'qs';
import { useInfiniteQuery } from '@tanstack/react-query';
const ENDPOINT = '/ajax/users/available-users';
const RANGE = 20;
const useAvailableUsers = (search, t0) => {
  const $ = _c(13);
  let queryParams;
  let shouldFetchOnMount;
  if ($[0] !== t0) {
    ({
      shouldFetchOnMount,
      ...queryParams
    } = t0);
    $[0] = t0;
    $[1] = queryParams;
    $[2] = shouldFetchOnMount;
  } else {
    queryParams = $[1];
    shouldFetchOnMount = $[2];
  }
  let t1;
  if ($[3] !== queryParams || $[4] !== search) {
    t1 = ["available-users", search, queryParams];
    $[3] = queryParams;
    $[4] = search;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== queryParams || $[7] !== search) {
    t2 = async t3 => {
      const {
        pageParam
      } = t3;
      const headers = new Headers();
      headers.append("X-Requested-With", "XMLHttpRequest");
      headers.append("range", `items=${pageParam}-${Number(pageParam) + RANGE - 1}`);
      const options = {
        method: "GET",
        headers
      };
      const {
        isMentorOnly,
        organizationId,
        excludeIds,
        ...otherQueryParams
      } = queryParams;
      const parameters = {
        q: search,
        ...otherQueryParams
      };
      if (isMentorOnly) {
        parameters.mentor = true;
      }
      if (organizationId) {
        parameters.organization = organizationId;
      }
      if (excludeIds) {
        parameters.user_id_not_in = excludeIds;
      }
      const parametersStringified = qs.stringify(parameters);
      const response = await fetch(`${ENDPOINT}?${parametersStringified}`, options);
      const jsonResponses = await response.json();
      let rangeEnd;
      let total;
      const contentRange = response.headers.get("Content-Range");
      if (contentRange) {
        rangeEnd = Number(contentRange.replace(/.*-(.*)\/.*/, "$1"));
        total = Number(contentRange.replace(/.*\/(.*)/, "$1"));
      } else {
        total = jsonResponses.length;
        rangeEnd = total;
      }
      return {
        rangeEnd,
        total,
        users: jsonResponses
      };
    };
    $[6] = queryParams;
    $[7] = search;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = Boolean(shouldFetchOnMount || search);
  let t4;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = {
      queryKey: t1,
      initialPageParam: 0,
      queryFn: t2,
      getNextPageParam: _temp,
      retry: 1,
      refetchOnWindowFocus: false,
      enabled: t3
    };
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return useInfiniteQuery(t4);
};

// eslint-disable-next-line import/prefer-default-export
export { useAvailableUsers };
function _temp(t0) {
  const {
    rangeEnd: rangeEnd_0,
    total: total_0
  } = t0;
  return rangeEnd_0 + 1 >= total_0 ? false : rangeEnd_0 + 1;
}